import * as React from "react"
import { ThemeProvider as CustomThemeProvider, useTheme } from "@/lib/theme-context"
import { setTheme as apiSetTheme } from "@/lib/api"

const ThemeSyncManager: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const { theme } = useTheme();

  // Effect to sync theme changes to backend.
  React.useEffect(() => {
    // We only sync when the theme is resolved to a value.
    // This will sync the theme from localStorage on initial load, and
    // any subsequent changes made by the user.
    if (theme) {
      apiSetTheme(theme).catch(err => {
        // Not showing a toast here to avoid user annoyance on startup/network issues.
        console.error("Failed to sync theme to backend:", err);
      });
    }
  }, [theme]);

  return <>{children}</>;
}


export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <CustomThemeProvider>
      <ThemeSyncManager>
        {children}
      </ThemeSyncManager>
    </CustomThemeProvider>
  )
}